import BaseService from '@/services/BaseService';

class HubspotInfoService extends BaseService {
    getHubspotInfo = () => this.get('/get-hubspot-info');

    addHubspotInfo = (data) => this.post('/add-hubspot-info', data);

    syncObjectsWithHubspot = (data) => this.post('/sync-objects-with-hubspot', data);
}

export default new HubspotInfoService();
